import { Exception } from '../../exceptions/exception';

export class RouteParamsNotFoundExceptions extends Exception {
  public constructor(message = 'Route params not found.') {
    super(message);
  }
}
